export default __webpack_public_path__ + "bf19b89c4395cf7a8d3db4c88c036690.png";